(() => {
  const SLOT_SEL = '[data-earn-points-slot]';

  const isEarnNode = (el) => {
    if (!el) return false;
    if (el.id === 'loy-potential-points') return true;
    if (el.getAttribute?.('data-block-id')?.includes('potential_points')) return true;
    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    return /earn/i.test(text) && /points/i.test(text) && /buy this item/i.test(text);
  };

  const findEarnFor = (slot) => {
    const root =
      slot.closest('.product-info') ||
      slot.closest('.shopify-section') ||
      document;

    const buy = slot.closest('.product-info__block-item[data-block-type="buy-buttons"]');
    if (buy) {
      let sibling = buy.nextElementSibling;
      while (sibling) {
        if (isEarnNode(sibling) || sibling.querySelector?.('#loy-potential-points, [id*="potential-points"]')) {
          return sibling;
        }
        if (sibling.getAttribute('data-block-type') === 'buy-buttons') break;
        sibling = sibling.nextElementSibling;
      }
    }

    return root.querySelector(
      '.product-info__block-item[data-block-id*="potential_points"], #loy-potential-points'
    );
  };

  const attachOne = (slot) => {
    const earn = findEarnFor(slot);
    if (!earn) return false;

    const widget =
      earn.id === 'loy-potential-points'
        ? earn
        : earn.querySelector?.('#loy-potential-points');
    const shell =
      earn.closest?.('.product-info__block-item') ||
      (earn.classList?.contains('product-info__block-item') ? earn : null);

    if (widget) {
      if (slot.contains(widget)) return true;
      slot.appendChild(widget);
      if (shell && shell !== widget && !shell.contains(slot)) {
        shell.hidden = true;
        shell.style.setProperty('display', 'none');
      }
      return true;
    }

    if (slot.contains(earn)) return true;
    slot.appendChild(earn);
    return true;
  };

  const attachAll = () => {
    const slots = document.querySelectorAll(SLOT_SEL);
    if (!slots.length) return false;
    let ok = false;
    slots.forEach((slot) => {
      if (attachOne(slot)) ok = true;
    });
    return ok;
  };

  let tries = 0;
  const tick = () => {
    tries += 1;
    if (attachAll() || tries > 40) {
      window.clearInterval(timer);
    }
  };

  tick();
  const timer = window.setInterval(tick, 250);
  document.addEventListener('DOMContentLoaded', tick);
  window.addEventListener('load', tick);
})();
